import { Col, DatePicker, Flex } from "antd"
import { use, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchTelecallerReportSummary } from "../../store/telecaller/telecallerSummary"
import StatsCard from "./SummaryCard"
import moment from "moment"

const TelecallerSummaryReport = () => {
    const { tele_report_summary, tele_report_summary_loading } = useSelector((state) => state.telecallerSummary);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchTelecallerReportSummary());
    }, [dispatch])

    const durationCards = [
        { key: "answer_duration", title: "Answer Duration" },
        { key: "available_time", title: "Available Time" },
        { key: "login_duration", title: "Log in Duration" },
        { key: "lunch", title: "Lunch" },
        { key: "on_call_duration", title: "On Call Duration" },
        { key: "ring_time", title: "Ring Time" },
        { key: "talk_time", title: "Talk Time" },
        { key: "total_breaks", title: "Total Breaks" },
        { key: "wrap_time", title: "Wrap Time" },
    ];

    return (
        <div className="telecaller-summary-report-container">
            <Flex className="page_title">
                <h3>Summary Report</h3>
                <DatePicker
                    disabledDate={(current) => {
                        // disable today and all future dates
                        return current && current >= moment().startOf('day');
                    }}
                    onChange={(val) => {
                        if (!val) {
                            dispatch(fetchTelecallerReportSummary());
                        } else {
                            const date = val.format("YYYY-MM-DD");
                            dispatch(fetchTelecallerReportSummary({ date }));
                        }
                    }}
                />


            </Flex>
            <div className="summary-reports-cards">
                {durationCards.map(({ key, title }) => (
                    <StatsCard
                        key={key}
                        title={title}
                        time={tele_report_summary?.[0]?.[key]}
                        loading={tele_report_summary_loading}
                    />
                ))}
            </div>
        </div>
    )
}
export default TelecallerSummaryReport